function SSShareOptions(config){
  this.config = config;
  this.renderTo = config.renderTo;
  this.html = this.config.html;
  this._init();
}

SSShareOptions.prototype._init = function(){
  
};

SSShareOptions.prototype.show = function(){
  var that = this;
  this.shareOptions = $('<div/>').html(this.html).appendTo(this.renderTo);
  this.setShareObjects();
  $.each({
    '.thirdPartyShare a.Twitter' : this.config.twitterShare,
    '.thirdPartyShare a.Linkedin' : this.config.linkedinShare
  }, function(selector, url){
    that.shareOptions.find(selector).bind('click', function(e){
      e.preventDefault();
      window.open( url, 'ss_share', 'width=660,height=490,toolbar=no,resizable=fixed,status=no,scrollbars=no,' +
      'menubar=no,screenX=0,screenY=0' ).focus();
    });
  });

  // Facebook like iframe does not use a popup
  this.fbLike.replaceWith(this.config.facebookLike);
};

SSShareOptions.prototype.setShareObjects = function(){
  this.twitter = this.shareOptions.find(".Twitter");
  this.linkedIn = this.shareOptions.find(".Linkedin");
  this.fbLike = this.shareOptions.find(".fb-like");
};